﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserProfileForm_1 = require("./UserProfileForm");
exports.UserProfileForm = UserProfileForm_1.UserProfileForm;
//# sourceMappingURL=index.js.map